<div>
  <alert [type]="type" >{{ message }}</alert>
</div>